export const CHART_RESPONSIVENESS = true;
export const CHART_THICKNESS = 10; // this thickness of the doughnut chart, max is 100
export const CHART_TITLE = "";
export const CHART_COLOR_ORANGE = "#ff923e";
export const CHART_COLOR_RED = "#e6464a";
export const CHART_COLOR_GREEN = "#40bc39";
export const CHART_COLOR_UNSCORED = "#778899";
export const CHART_SHOW_TITLE = false;